/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "The colleagues you have 1:1s with appear here, so you can quickly find your previous and upcoming conversations. Wundo takes them from your calendar: schedul..." |
*
* @param {Team_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_empty_body = /** @type {((inputs?: Team_Empty_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Empty_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hier verschijnen de collega's met wie je 1:1's hebt, zodat je jullie vorige en volgende gesprekken snel terugvindt. Wundo haalt ze uit je agenda: plan een 1:1 in en die collega verschijnt hier vanzelf. Alleen jij ziet dit overzicht.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ici apparaissent les collègues avec qui vous avez des one-to-ones, pour retrouver vite vos échanges passés et à venir. Wundo les trouve dans votre agenda : planifiez un one-to-one et ce collègue apparaîtra ici tout seul. Cet aperçu n'est visible que par vous.")
	return /** @type {LocalizedString} */ ("The colleagues you have 1:1s with appear here, so you can quickly find your previous and upcoming conversations. Wundo takes them from your calendar: schedule a 1:1 and that colleague appears here on their own. Only you can see this overview.")
});